<div class="modal-header">
  <h4
    class="modal-title"
    i18n
  >Recap has moved to a new domain</h4>
</div>
<div class="modal-body">
  <p i18n>
    You're currently accessing Recap from a deprecated address.
    A new domain is now in use for your environment, and this one will soon be deprecated.
    Please switch to the updated domain to continue.</p>
</div>
<div class="modal-footer">
    <a
      class="btn btn-primary rounded"
      href="{{targetUrl}}"
      i18n
    >Continue on new domain</a>
</div>